import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { propType } from 'graphql-anywhere'
import { T } from 'ramda'

import TileFields from '../../../../graphql/fragments/tile.gql'
import styles from '../cancel-subscription.css'
import CarouselTile from '../../carousel/tile'
import { THEME_OPTIONS } from '../../../constants'
import { useScreenWidth } from '../../../hooks/use-screen-width'
import { getResponsiveTileShowCount } from '../../../lib/utils'
import EmblaCarousel from '../../emblaCarousel'

function Carousel({
  carousel,
  theme,
  isContentItemOnMyList,
  addToMyList,
  removeFromMyList
}) {
  const screenWidth = useScreenWidth()
  const tilesShowCount = getResponsiveTileShowCount(screenWidth, 2)

  return (
    <>
      <div className={styles.section}>
        <div className={classNames(styles.header, styles.carouselHeader)}>
          There&apos;s still so much to see!
        </div>
        <div className={classNames(styles.copy, styles.carouselCopy)}>
          Stay for the latest blockbusters, trending series, and hidden gems you won&apos;t find anywhere else.
        </div>
        <div className={styles.carouselTilesWrapper}>
          <EmblaCarousel
            slidesToShow={tilesShowCount}
            activeSlideCount={carousel.tiles.length}
          >
            {carousel.tiles.map((tile, index) => {
              return (
                <div
                  className={styles.emblaSlide}
                  key={tile.id}
                >
                  <CarouselTile
                    tile={tile}
                    theme={theme}
                    index={index}
                    contentType={carousel.contentType}
                    listTitle="Cancel Journey Landing Carousel"
                    addToMyList={addToMyList}
                    removeFromMyList={removeFromMyList}
                    isOnMyList={isContentItemOnMyList(tile.contentItem.id)}
                  />
                </div>
              )
            })}
          </EmblaCarousel>
        </div>
      </div>
    </>
  )
}

Carousel.propTypes = {
  carousel: PropTypes.shape({
    tiles: PropTypes.arrayOf(propType(TileFields)).isRequired,
    contentType: PropTypes.string,
    subType: PropTypes.string,
    header: PropTypes.string
  }).isRequired,
  theme: PropTypes.string,
  isContentItemOnMyList: PropTypes.func,
  addToMyList: PropTypes.func,
  removeFromMyList: PropTypes.func
}

Carousel.defaultProps = {
  theme: THEME_OPTIONS.dark,
  addToMyList: T,
  removeFromMyList: T,
  isContentItemOnMyList: T
}

export default Carousel
